import {Locale} from '../../../types/locale';

export const getDataClientId = (locale: Locale) => {
  switch (locale) {
    case Locale.de_DE:
    case Locale.en_DE:
      return '1e8dd5ac-06a3-5878-9642-ec7dcd7bc061';
    case Locale.de_CH:
    case Locale.fr_CH:
    case Locale.it_CH:
    case Locale.en_CH:
      return '8e8f24bf-9dcb-5760-a7ee-1d25dd188bc3';
    case Locale.de_AT:
    case Locale.en_AT:
      return '6cc8be8e-ee24-5964-afa6-306b04942e7c';
    case Locale.nl_BE:
    case Locale.fr_BE:
      return 'a34c47aa-31ba-5d22-8b34-22e379e72a20';
    case Locale.nl_NL:
    case Locale.en_NL:
      return '134d889a-3ca8-5596-b095-a8e85e377279';
    case Locale.sv_SE:
      return '0d7a72e1-c8af-5316-9552-bde4a83ac0e4';
    case Locale.da_DK:
      return 'a159b032-144d-5715-af3c-4749d75c2e17';
    case Locale.fi_FI:
      return '605a0267-7836-560e-85b9-314d7c604ea7';
    case Locale.fr_FR:
      return '2563b9c4-b5ff-5044-9227-9222aa5fd4d7';
    case Locale.es_ES:
      return '359a7a93-f37d-5701-b56d-5a035b33a5d2';
    case Locale.it_IT:
      return '189aa903-80e1-51c5-9407-176f8bfd68ba';
    case Locale.pt_PT:
      return '715c5438-9d56-56a0-8d36-fc55ea282e73';
    case Locale.pl_PL:
      return 'a387c7c8-4a24-5eb8-ae45-b4a26df4a27d';
    case Locale.ro_RO:
      return '759ea8b4-f087-5c30-97f8-221638355ec1';
    default:
      return '';
  }
};
